/**
 * LegalFooter
 * @returns <LegalFooter />
 */

const LegalFooter = ({content}) => {
  return (
      <div className="legal-footer">
          <div
              className="wrapper"
              dangerouslySetInnerHTML={{ __html: content }}
          ></div>
      </div>
  );
}

export default LegalFooter